import { ResultsTypes } from '../../hooks/components/useDispensarization/types';

export enum FormType {
  MonitoringDiabetesMellitus = 'MonitoringDiabetesMellitus',
  MonitoringElderlyPatient = 'MonitoringElderlyPatient',
  MonitoringHepatitis = 'MonitoringHepatitis',
  MonitoringTuberculosis = 'MonitoringTuberculosis',
  MonitoringOncological = 'MonitoringOncological',
  MonitoringChronicObstructivePulmonaryDisease = 'MonitoringChronicObstructivePulmonaryDisease',
  MonitoringHeartFailure = 'MonitoringHeartFailure',
  MonitoringCoronaryHeartDisease = 'MonitoringCoronaryHeartDisease',
  MonitoringAsthma = 'MonitoringAsthma',
  MonitoringArterialHypertension = 'MonitoringArterialHypertension',
  MonitoringSarsCovid19 = 'MonitoringSarsCovid19',
  Survey = 'Survey',
  QualityEstimation = 'QualityEstimation',
  MonitoringDispensary = 'MonitoringDispensary',
  Hospitalization = 'Hospitalization',
}

export interface BatchForm {
  id: string;
  name: string;
  from: string;
}

export interface FormTemplate {
  id: string;
  name: string;
  createdDateTime?: string;
  isDelete?: boolean;
  createdUserId?: string;
  questions?: FormTemplateQuestion[];
}

export interface FormTemplatesResponse {
  pageIndex: number;
  totalItemsCount: number;
  items: FormTemplate[];
}

export enum FormAnswerRestriction {
  YesNo = 'YesNo',
  Number_1_5 = 'Number_1_5',
  Number_1_10 = 'Number_1_10',
  Number = 'Number',
  Text = 'Text',
  Date = 'Date',
}

export interface FormQuestion {
  id?: string;
  value: string;
}

export interface FormTemplateQuestion {
  id?: string;
  order: number;
  question: FormQuestion;
  restriction: FormAnswerRestriction;
}

export interface CreateFormTemplateQuestionRequest {
  order: number;
  question: string;
  restriction: FormAnswerRestriction;
}

export type CreateFormTemplateQuestionDraft =
  CreateFormTemplateQuestionRequest & {
    clientId?: string;
  };

export interface CreateFormTemplateRequest {
  name: string;
  questions: CreateFormTemplateQuestionRequest[];
}

export type Guid = string;

export interface ItemDto<TKey> {
  key: TKey;
  value?: string;
}

export type FormAnswerRestrictionsResponse = ItemDto<FormAnswerRestriction>[];
export type UserListResponse = ItemDto<Guid>[];

export type FormAnswerRestrictionLabels = Partial<
  Record<FormAnswerRestriction, string>
>;

export interface FormAnswerRestrictionOption {
  value: FormAnswerRestriction;
  label: string;
}

export interface TaskFormItem {
  id: string;
  tenantId?: string;
  createdDateTime: string;
  expectedCallDateTime: string;
  hisPatientId?: string;
  phone: string;
  surname?: string;
  givenName?: string;
  patronym?: string;
  gender?: number;
  birthDate?: string;
  state?: ResultsTypes;
  status?: string;
  result?: ResultsTypes;
  clinic?: {
    id?: string;
    name: string;
  };
  type: FormType;
  template?: FormTemplate;
  batch: BatchForm;
}

export interface TaskFormTableRow {
  id: string;
  phone: string;
  patientFullName: string;
  date: string;
  clinic?: string;
  campaign?: string;
  batchFrom?: string;
  formType?: FormType;
  formTypeLabel?: string;
  formTemplate?: string;
  state?: ResultsTypes;
  status?: string;
  result?: ResultsTypes;
  indexId: number;
}
